import ACTIONS from '~shared/actions';
import { Grow2792StateType } from './types';
import { CombinedActions } from '~shared/types/pricing/actions';

export const grow2792State: Grow2792StateType = {
  advantageUsers: 1,
  premierUsers: 1,
  initialLoad: true,
};

export default function Grow2792Reducer(state: Grow2792StateType, action: CombinedActions): Grow2792StateType {
  if (action.type === ACTIONS.PNP_REFRESH_RESET_TOGGLE_SWITCH) {
    return {
      ...state,
      advantageUsers: 1,
    };
  }

  if (action.type === ACTIONS.PNP_REFRESH_CHANGE_USERS) {
    return {
      ...state,
      [action.payload.packageType]: action.payload.users,
    };
  }

  if (action.type === ACTIONS.PNP_REFRESH_INITIAL_LOAD) {
    return {
      ...state,
      initialLoad: action.payload.loadedState,
    };
  }

  if (action.type === ACTIONS.PNP_REFRESH_RESET_ALL) {
    return grow2792State;
  }

  return state;
}
